import CountriesByISOCode from "./countries";

export default class Utilities {

	static GetRandomString(len) {
		let text = "";
		let possible = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789";

		for (var i = 0; i < len; i++)
			text += possible.charAt(Math.floor(Math.random() * possible.length));

		return text;
	}

	static GetRandomStringStartingWithLetter(len) {
		let text = Utilities.GetRandomString(len)

		if (text.match(/^\d/)) {
			text = text.substr(1);
			let possible = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz"
			text = possible.charAt(Math.floor(Math.random() * possible.length)) + text
		}

		return text;
	}

	static CopyNodeContent(elnode) {
		try {
			window.getSelection().removeAllRanges();
			const range = document.createRange();
			range.selectNode(elnode);
			window.getSelection().addRange(range);
			document.execCommand("copy");
			let copiedtext = window.getSelection().toString();
			window.getSelection().removeAllRanges();
			return copiedtext
		}
		catch {
			return null;
		}

	}

	static GetFormattedPhoneNumber(sMobileCountryIsoCodeNumber, sLocalNumber, bHidePrefix) {
		// sMobileCountryIsoCodeValue es: "39"
		// sLocalNumber es: "3425110984"
		var sInternationalPrefix = "";
		var sFormattedLocalNumber = "";
		var sFinalNumber = "";

		// Funzioni
		var fnTryParseInt = function (sIsoPrefix) {
			var retValue = null;
			if (sIsoPrefix !== null) {
				if (sIsoPrefix.length > 0) {
					if (!isNaN(sIsoPrefix)) {
						retValue = parseInt(sIsoPrefix);
					}
				}
			}
			return retValue;
		}

		// Controllo che sia passato un valore di prefisso corretto. Se viene passato invece "ITA" allora lo converto a "39"
		var parsedIsoCodeNumber = fnTryParseInt(sMobileCountryIsoCodeNumber);
		if (parsedIsoCodeNumber == null) {
			var oCountryIso = CountriesByISOCode[sMobileCountryIsoCodeNumber];
			if (oCountryIso) {
				sMobileCountryIsoCodeNumber = oCountryIso.P;
				sInternationalPrefix = fnTryParseInt(oCountryIso.P).toString();
			}
		}
		else
			sInternationalPrefix = parsedIsoCodeNumber.toString();

		// Definisco se esiste l'oggetto con le informazioni relative a quel paese
		var sCountryIsoCode = Object.keys(CountriesByISOCode).filter(function (key) {
			if (CountriesByISOCode[key].P == sInternationalPrefix) {
				return CountriesByISOCode[key];
			}
		})[0];

		if (sCountryIsoCode == null)
			return null;

		// Determino il trunk prefix ed eseguo la pulizia del numero telefonico se necessario
		var trunkPrefix = CountriesByISOCode[sCountryIsoCode].TrunkPrefix;
		if (trunkPrefix) {
			if (typeof (trunkPrefix) == "object") {
				for (var key in trunkPrefix) {
					var iChars = trunkPrefix[key].length;
					if (sLocalNumber.indexOf(trunkPrefix[key]) == 0) {
						sLocalNumber = sLocalNumber.substr(iChars);
						break;
					}
				}
			}
			else {
				var iChars = trunkPrefix.length;
				if (sLocalNumber.indexOf(trunkPrefix) == 0) {
					sLocalNumber = sLocalNumber.substr(iChars);
				}
			}
		}

		sFormattedLocalNumber = sLocalNumber;

		// Ritorno il numero formattato
		if (bHidePrefix == true)
			sFinalNumber = sFormattedLocalNumber;
		else
			sFinalNumber = "+" + sInternationalPrefix + " " + sFormattedLocalNumber;

		return sFinalNumber;
	}
}